<template>
  <div class="chart-container">
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <span>{{$t('sensorOverlay')}}</span>
      </div>
      <div class="main-header-right" :class="{'it1':isIt||isFr}">
        <button @click="print"><span >{{$t('print')}}</span></button>
        <button class="set" @click="open"><span >{{$t('set')}}</span></button>
        <p>{{$t('period')}}:<span class="time">{{timeRange3}}</span></p>
      </div>
    </div>
    <hr class="small-hr spe-hr">
    <div   >
    <el-row>
      <el-col :span="24">
        <div id="chart3_1" class="graph" :element-loading-text="loadingText"  v-loading="loading"></div>
      </el-col>
    </el-row>
    </div>
    <hr class="small-hr">
    <div class="legend-group">
      <div class="legend" v-show="show.A"><img src="../../assets/Line_1.png"><span>{{legendDate[0]}}</span></div>
      <div class="legend" v-show="show.B"><img src="../../assets/Line_2.png"><span>{{legendDate[1]}}</span></div>
      <div class="legend" v-show="show.C"><img src="../../assets/Line_3.png"> <span>{{legendDate[2]}}</span></div>
      <div class="legend" v-show="show.D"><img src="../../assets/Line_4.png"><span>{{legendDate[3]}}</span></div>
      <div class="legend" v-show="show.E"><img src="../../assets/Line_5.png"><span>{{legendDate[4]}}</span></div>
      <div class="legend" v-show="show.F"><img src="../../assets/Line_6.png"><span>{{legendDate[5]}}</span></div>
      <div class="legend" v-show="show.G"><img src="../../assets/Line_7.png"><span>{{legendDate[6]}}</span></div>
      <div class="legend legend-spe2"><img src="../../assets/Average.png"><span>{{$t('Average')}}</span></div>
      <div style="clear: both;"></div>
    </div>

    <div class="statics" id="sa_stat_table">
      <table class="statics-table">
        <tr>
          <td class="td1">{{$t('date')}}</td><td class="td1">{{$t('Avg')}}</td> <td class="td1">{{$t('min')}}</td>
          <td class="td1">{{$t('max')}}</td> <td class="td2">{{$t('ofhypo')}}</td>
        </tr>
        <tr v-for="(item,i) in date" v-show="item">
          <td class="td1">{{item}}</td><td class="td1">{{glucose[i].avg}}</td>
          <td class="td1">{{glucose[i].min}}</td><td class="td1">{{glucose[i].max}}</td> <td class="td2">{{glucose[i].nh}}</td>
        </tr>
        <tr>
          <td class="td3">{{$t('overall')}}</td> <td class="td3">{{glucose[glucoseLength].avg}}</td> <td class="td3">{{glucose[glucoseLength].min}}</td>
          <td class="td3">{{glucose[glucoseLength].max}}</td> <td>{{glucose[glucoseLength].nh}}</td>
        </tr>
      </table>
    </div>

    <!--Add对话框-->
    <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize  id="dialog-form2" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('setPeriod')}}</span>
        <img src="../../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div class="time-range" :class="{'zh2':!isEn}">
            <p>{{$t('From')}}</p>
            <div class="date">
              <span>{{startDate}}</span>
            </div>
            <p>{{$t('To')}}</p>
            <div class="block">
              <el-date-picker v-model="value1" type="date"  :editable=false  :picker-options="pickerOptions"
                              :clearable=false  :placeholder="defaultDate"    format="dd-MM-yyyy" @change="procTimeRangeSelect">
              </el-date-picker>
            </div>
        </div>
        <hr class="patientList-small-hr">
        <div class="weeks" id="weeks" :class="{'zh3':!isEn}">
          <span class="tittle" :class="{'zh4':!isEn}"><label @click="chooseAll">{{$t('Weekdays')}}</label></span>
          <span><label @click="choose">{{$t('Mon')}}</label></span>
          <span><label @click="choose">{{$t('Tue')}}</label></span>
          <span><label @click="choose">{{$t('Wed')}}</label></span>
          <span><label @click="choose">{{$t('Thur')}}</label></span>
          <span><label @click="choose">{{$t('Fri')}}</label></span>
        </div>
        <div class="weeks weken" id='weken' :class="{'zh3':!isEn}">
          <span class="tittle" :class="{'zh5':!isEn,'de5':isDe,'it5':isIt,'po5':isPo,'du5':isDu,'sw5':isSw,'cz5':isCz}"><label @click="chooseAll" >{{$t('Weekends')}}</label></span>
          <span><label @click="choose" >{{$t('Sat')}}</label></span>
          <span class="weeken-spe" :class="{'it2':isIt,'po2':isPo,'du2':isDu,'fr3':isFr,'sw2':isSw,'cz2':isCz}" ><label @click="choose">{{$t('Sun')}}</label></span>
        </div>
        <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button @click="dateApply">{{$t('applyM')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  import {loading} from '../mixins/loading'
  import format from '@/lib/format'
  /*
  Notes:
  2019-8-6

  * */
  export default{
    mixins: [loading],
    data() {
      return {
        chartWidth: '', timer: false,typeChooseVisible:false, value1:'',isC:false, flag:0,count:0, sta:'',end:'',Average:[],
        chart3_1: null, startDate:'',  timeRange3:'',defaultDate:'',whichDay:'Everyday', weekmode:'yyyyyyy',isMg:'',ts:[],isFr:false,
        legendDate:['','','','','','',''], Kday:[],DataSG:[],calib:[],bg:[],isEn:false,avg:[],isCz:false,
        show:{A:false,B:false,C:false,D:false,E:false,F:false,G:false,},dialogSize:'tiny',i:0,weekModeSp:[],weekM1:false,weekM2:false,isSw:false,
        uid:0,st:0,et:0, startTine:1505836800000,isDe:false,isIt:false,isPo:false,isDu:false,
        pickerOptions:{
          disabledDate(time){
            let t1=time.getTime();
            let d2=new Date();
            let t2=d2.getTime();
            //return (t1>t2 || (d2.getYear()-time.getYear())>2 );
            return (t1>t2 || t1<(t2-730*86400*1000));
          }
        },
        textStyle: {
          color: '#282828',
          fontWeight: 'normal',
          fontSize: '14',
          fontFamily: 'SFUIText-Regular'
        },
        titlePadding: [0, 0, 8, 33],
        grid: {x: '3%', y: '4%', width: '94.5%', height: '89%'},
        yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},

        glucose:[[],[],[],[],[],[],[],[]],glucoseLength:7,date:[],
      }
    },
    computed: {
      DataS(){
        return this.$store.state.DataS;
      },
    },
    methods:{
      getData(){
        this.ts = auth.getTs2(this,this.st,this.et);
        /*let param = {
          ts:this.ts,
          tz:parseInt(sessionStorage.getItem('tz')),
          weekmode:this.weekmode,
        };*/
        // window.location.reload();
        this.$emit('reload')
       // param = B64.base64encode(JSON.stringify(param));
        //auth.getOl(this,this.uid,param);
      },
      procTimeRangeSelect(e){
        let et=this.value1.getTime()/1000;
        let st=et-86400*(7-1);
        this.startDate=format.formatterDate4(st);
      },
      drawChart3_1() {
        let that =this;
        this.chart3_1 = echarts.init(document.getElementById('chart3_1'));
        this.registLoading('chart3_1',this.chart3_1)
        this.chart3_1.setOption({
          title: {
            text: (this.isMg)? this.$t('SG')+' (mg/dL)':this.$t('SG')+' (mmol/L)',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          tooltip:{
            trigger:'axis',
            axisPointer:{
              type:'line',
              axis:'x',
              lineStyle:{color:'#333',}
            },
            backgroundColor:'#555',
            textStyle:{
              color: ' #ffffff',
            },
            formatter:function(params){
              let tip = format.formatterTip3(params,that);
              return tip ;
            },
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.startTime),
            max:new Date(this.startTime+8.64e7),
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
            splieLine:{show:true},
            axisLabel:{
              showMaxLabel:true,
              margin: 15, textStyle: {color: '#282828', baseline: 'middle'} ,
              formatter:function (value,index) {
                // let H = new Date(value).getHours();
                index=(value - that.startTime) / 3600000;
                let H=index;
                if(index<24){
                  if(index%3===0){
                    H = H<10 ? ('0'+H+':00' ): H+':00';
                    return  H;
                  }else{
                    return ' ';
                  }
                }else{
                  return  '24:00';
                }
              }
            },
            axisPointer:{snap:false}
          }],
          yAxis: [{
            type: 'value',
            min:0,max:(this.isMg)? 400:25,
            axisLabel: this.yAxisLabel,
            axisLine: {lineStyle: {color: '#ccc'}},
            boundaryGap: false,
            axisTick: {length: 0},
          }],
          grid: this.grid,
          animation:false,
          series: [
            {
              type:'scatter',
              data:this.DataSG[0],
              markArea: {
                data: [ [{yAxis: (this.isMg)?this.DataS.target_low*18:this.DataS.target_low}, {yAxis:(this.isMg)?this.DataS.target_high*18:this.DataS.target_high}]],
                tooltip:{show:false,},
                silent:true,
                itemStyle: {normal: {color: 'rgba(211,255,213,0.6)',},}
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.DataS.hypo*18:this.DataS.hypo}],
                symbol:['circle','circle'],
                silent:true,
                symbolSize: 1,
                tooltip:{backgroundColor:'#777',formatter:''+this.DataS.hypo.toFixed(1)+'',textStyle:{color:'#f00'}},
                lineStyle: {normal: {
                  color: 'rgba(255,0,0,0.5)',
                  type: 'solid',
                }},
                label:{normal:{show:false}},
            },
              itemStyle: {normal: {color:'#3ce8dc',}},
              tooltip:{backgroundColor:'#777',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'||params.value[2]==='NC'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
                textStyle:{color:'#3ce8dc'}
              },
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[1],
              itemStyle: {normal: {color:'#2842d2',}},
              tooltip:{backgroundColor:'#777',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'||params.value[2]==='NC'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
                textStyle:{color:'#2842d2'}
              },
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[2],
              itemStyle: {normal: {color:'#79bd39',}},
              tooltip:{backgroundColor:'#777',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'||params.value[2]==='NC'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
                textStyle:{color:'#79bd39'}
              },
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[3],
              itemStyle: {normal: {color:'#dce573',}},
              tooltip:{backgroundColor:'#777',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'||params.value[2]==='NC'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
                textStyle:{color:'#dce573'}
              },
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[4],
              itemStyle: {normal: {color:'#e61795',}},
              tooltip:{backgroundColor:'#777',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'||params.value[2]==='NC'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
                textStyle:{color:'#e61795'}
              },
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[5],
              itemStyle: {normal: {color:'#c9711e',}},
              tooltip:{backgroundColor:'#777',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'||params.value[2]==='NC'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
                textStyle:{color:'#c9711e'}
              },
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.DataSG[6],
              itemStyle: {normal: {color:'#a922d9',}},
              tooltip:{backgroundColor:'#777',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'||params.value[2]==='NC'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
                textStyle:{color:'#a922d9'}
              },
              symbolSize:3,
            },
            {
              type:'scatter',
              data:this.avg,
              itemStyle: {normal: {color:'#464646',}},
              tooltip:{backgroundColor:'#777',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 17px;background:#000;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
                textStyle:{color:'#fff'}
              },
              symbolSize:3,
            },
            {
              type: 'scatter',
              data: this.calib,
              symbol:'image://static/legend/calib.png',
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  params.value[2]+' '+time[0]+':'+time[1]+',Calibration  '+params.value[1];
                },
              },
            },
            {
              type: 'scatter',
              data: this.bg,
              symbol:'image://static/legend/calibrate_1.png',
              symbolSize:[10,20],
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  params.value[2]+' '+time[0]+':'+time[1]+',BG '+params.value[1];
                },
              },
            },
          ],
        },false,true);

      },
      handleResize(){
        let win = window.innerWidth;
        let scale = (win<1500)?0.91:0.62;
        const chartWidth = win * scale * 0.98 * 0.94 + 'px';
        let chart3_1 = document.getElementById('chart3_1');
        if(chart3_1){
          chart3_1.style.width = chartWidth;
        }
      },
      cancel(){
          this.typeChooseVisible=false;
      },
      choose(e){
        const parent = e.target.parentNode.parentNode;
        const labels =parent.getElementsByTagName('label');
        if(e.target.className===''){
          e.target.className = 'no';
          labels[0].className = 'no';
        }else{
          e.target.className = '';
          for(let i=1;i<labels.length;i++){
              if(labels[i].className===''){
                 this.count++;}
          }
          if(this.count===labels.length-1){
            labels[0].className = '';
          }
          this.count = 0;
        }
      },
      chooseAll(e){
        const parent = e.target.parentNode.parentNode;
        const labels =parent.getElementsByTagName('label');
        this.flag =(labels[0].className==='no')?1:0;/*初始化，判断接下来的点击是否全选*/
        for(let i=0;i<labels.length;i++){
          if(this.flag===0){
            labels[i].className = 'no';
          }else{
            labels[i].className = '';
          }
        }
      },
      open(){
       this.typeChooseVisible=true;
       auth.checkWeekMode(this);
       this.$nextTick(this.initWeeks);/*不能传参，未封装待优化*/
      },
      initWeeks(){
        const weeks = document.getElementById('weeks');
        const weken = document.getElementById('weken');
        const labels1 = weeks.getElementsByTagName('label');
        const labels2 = weken.getElementsByTagName('label');
        labels1[0].className=(this.weekM1)?'no':'';
        labels2[0].className=(this.weekM2)?'no':'';
        for(let i=1;i< labels1.length;i++){
          labels1[i].className=(this.weekModeSp[i-1])?'no':'';
        }
        for(let i=1;i< labels2.length;i++){
          labels2[i].className=(this.weekModeSp[i+4])?'no':'';
        }
      },

      dateApply(){
        this.end = this.value1;
        if(this.end===''){
           let t = this.defaultDate.split('-');
          this.end = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
          this.sta = this.end - 3600*24*6;
        }else{
          this.end = new Date(this.end).getTime()/1000;
          this.sta = this.end - 3600*24*6;
        }
        let weekmode = this.checkDate();
        //console.log(this.weekmode);
        if(weekmode!=='nnnnnnn'){
          this.weekmode = weekmode;
          this.st = this.sta;
          this.et = this.end;
          this.startTime =this.st*1000;
          this.sta = format.formatterDate2(this.sta);
          this.end = format.formatterDate2(this.end);
          this.timeRange3 = this.sta+'-'+this.end+', '+this.$t(this.whichDay);
          this.formatterSelect(this.sta,this.end);
          sessionStorage.setItem('st3',this.st);
          sessionStorage.setItem('et3',this.et);
          sessionStorage.setItem('week3',this.weekmode);
          sessionStorage.setItem('timeRange3',this.timeRange3);
          this.getData();
        }
        this.typeChooseVisible=false;
      },
      checkDate(){
        const weeks = document.getElementById('weeks');
        const weken = document.getElementById('weken');
        if(weeks){
          const labels1 = weeks.getElementsByTagName('label');
          const labels2 = weken.getElementsByTagName('label');
          let  weekmode='';
          if(labels1[0].className===''&&labels2[0].className===''){this.whichDay= 'Everyday';weekmode='yyyyyyy';}
          else{
            this.whichDay=' ';weekmode='';
            for(let i=1;i< labels1.length;i++){
              if(labels1[i].className===''){
                this.whichDay = this.whichDay+' '+labels1[i].innerHTML+'.';
                weekmode = weekmode+'y';
              }else{
                weekmode = weekmode+'n';
              }
            }
            for(let i=1;i< labels2.length;i++){
              if(labels2[i].className===''){
                this.whichDay = this.whichDay+' '+labels2[i].innerHTML+'.';
                 weekmode = weekmode+'y';
              }else{
                 weekmode = weekmode+'n';
              }
            }
          }
          return weekmode;
        }
      },
      //初始化
      init(){
          this.sta = format.formatterDate2(this.st);
          this.end = format.formatterDate2(this.et);
          this.formatterSelect(this.sta,this.end);
      },
      formatterSelect(st,et){
        st = st.split('/');
        et = et.split('/');
        this.startDate = st[0]+'-'+st[1]+'-'+st[2];
        this.defaultDate = et[0]+'-'+et[1]+'-'+et[2];
      },
      checkLegend(){
        let  legendTime =this.DataSG;
        this.legendDate =[];
        this.show = {A:false,B:false,C:false,D:false,E:false,F:false,G:false,};
        for(let i=0;i<legendTime.length;i++){
            if(legendTime[i]){
              let time = legendTime[i][0][0];
              time =new Date(time);
              let y1 = time.getFullYear();
              let m1 = time.getMonth()+1;
              let d1 = time.getDate();
               d1 = d1+this.Kday[i];
              // console.log(i,this.Kday[i],d1);
              if((m1===1||m1===3||m1===5||m1===7||m1===8||m1===10||m1===12)&&d1>31){
                 d1 = d1-31;
                 m1 = m1+1;
              }
              if((m1===4||m1===6||m1===9||m1===11)&&d1>30){
                d1 = d1-30;
                m1 =m1+1;
              }
              if((m1===2)&&d1>29){
                d1 = d1-29;
                m1 =m1+1;
              }
              if(m1>12){
                  m1 =m1-12;
                  y1 = y1+1;
              }
              m1 = m1<10 ? ('0'+m1 ): m1;
              d1 = d1<10 ? ('0'+d1) : d1;

              this.legendDate[i] =d1+'-'+m1+'-'+y1;
            }
        }
        //console.log( this.legendDate);
        if(this.legendDate[0]){this.show.A = true;}
        if(this.legendDate[1]){this.show.B = true;}
        if(this.legendDate[2]){this.show.C = true;}
        if(this.legendDate[3]){this.show.D = true;}
        if(this.legendDate[4]){this.show.E = true;}
        if(this.legendDate[5]){this.show.F = true;}
        if(this.legendDate[6]){this.show.G = true;}
      },
      getAverage(SG){
         // console.log(SG);
        let length=SG.length;
        let average = new Array(720);
        if(length>0){
          for(let j=0;j< 720;j++) {
            average[j] = new Array(2);
            average[j][0] = parseInt(this.startTime/1000)+j*120;
            average[j][1] =0;
            let num=0;
            for (let i = 0; i < length; i++) {
              //遍历所有元素，根据时间查找
              for(let k=0;k<720;k++){
                if(SG[i][k]){
                  let t = SG[i][k][0].getTime()/1000;
                  let mt = t-average[j][0];
                  if(mt<=120&&mt>=0){
                    average[j][1] =  average[j][1] + SG[i][k][1];
                    num++;
                  }
                }
              }
            }
            average[j][0] = new Date(average[j][0]*1000);
            average[j][1] = (average[j][1]/num).toFixed(1);
          }
          this.avg = average;
        }
        //console.log(this.avg)
      },
      getOlReportInfo(report_data){
        //console.log('report_data:', report_data);
        //let data =  res.data.data;
        let data=report_data;
        data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
        this.statics = data;
        this.devices = (data.devices)?data.devices:this.devices;
        this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
        this.glucose = (data.sg_stat)?data.sg_stat:this.glucose;
        //console.log(this.glucose )
        sessionStorage.setItem('ol_report_data', JSON.stringify(report_data))
      },
      print(){
        let src1 = this.chart3_1.getDataURL();
        sessionStorage.setItem('st3',this.st);
        sessionStorage.setItem('et3',this.et);
        sessionStorage.setItem('week3',this.weekmode);
        sessionStorage.setItem('timeRange3',this.timeRange3);
        sessionStorage.setItem('src3_1',src1);
        sessionStorage.setItem('legendDate3',JSON.stringify(this.legendDate));
        window.open('/#/chart3-print','_blank');
      }
    },
    beforeDestroy(){
      this.chart3_1.dispose();
      this.chart3_1 = null;
      this.DataSG = [];
    },
    mounted: function () {
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;

      if(!sessionStorage.getItem('st3')){
        var nd=new Date();
        var cur_day=new Date(nd.getFullYear(), nd.getMonth(), nd.getDate()-1)
        this.et=cur_day/1000;
        //this.et= new Date().setHours(0,0,0,0)/1000-86400;
        var chart_end_time=sessionStorage.getItem('chart_end_time')
        for (var d=0; d<3000; d++) {
          if (this.et>chart_end_time) {
            //this.et -= 24*3600;
            cur_day=new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate()-1)
            this.et=cur_day/1000;
          } else {
            break;
          }
        }
        this.st = this.et-86400*6;
        this.weekmode = 'yyyyyyy';
        this.timeRange3 = format.formatterDate2(this.st)+'-'+format.formatterDate2(this.et)+', '+this.$t(this.whichDay);
      }else{
        this.st = parseInt(sessionStorage.getItem('st3'));
        this.et = parseInt(sessionStorage.getItem('et3'));
        this.weekmode =sessionStorage.getItem('week3');
        //this.timeRange3 =sessionStorage.getItem('timeRange3');
        this.timeRange3 = format.formatterDate2(this.st)+'-'+format.formatterDate2(this.et)+', '+this.$t(this.whichDay);
      }
      this.value1=new Date(this.et*1000);
      this.init();
      this.ts = auth.getTs2(this,this.st,this.et);
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        weekmode:this.weekmode,
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      param = B64.base64encode(JSON.stringify(param));

      let length = this.ts.length;
      this.glucoseLength = length;

      for(let i=0;i<length;i++){
        let t = format.formatterDate9(this.ts[i][0]);
        t[1] = t[1]+1;
        t[1]=  t[1]<10 ? ('0'+ t[1] ):  t[1];
        t[2] = t[2]<10 ? ('0'+ t[2]) :  t[2];
        this.date[i] = t[2]+'-'+t[1]+'-'+t[0];
      }

      auth.getOl(this,this.uid,param);
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      let that = this;
      /*auth.getDataMap(this, this.uid, function(res){
        if (0!=res.error) {
          return;
        }
        var end_time=(res.end.cgms > res.end.pump)?res.end.cgms:res.end.pump;
        //console.log(param)
        var ts_size=param.ts.length;
        var time_offset=0;
        var cur_end=param.ts[ts_size-1][1];
        //console.log(cur_end + ', '+end_time);
        for (var d=0; d<3000;d++) {
          if(cur_end>end_time) {
            cur_end -= 24*3600;
          } else {
            break;
          }
        }
        //console.log(d)
        if (d)
          d -= 1;
        for (var i=0; i<ts_size; i++) {
          param.ts[i][0] -= 24*3600*d;
          param.ts[i][1] -= 24*3600*d;
        }
        that.st=param.ts[0][0];
        that.et=param.ts[ts_size-1][0];
        that.timeRange3 = format.formatterDate2(that.st)+'-'+format.formatterDate2(that.et)+', '+that.$t(that.whichDay);
        //
        console.log(param)
        param = B64.base64encode(JSON.stringify(param));
        auth.getOl(that,that.uid,param);
        that.init()
      })*/
      window.onresize = function () {
        that.handleResize();
        if(that.chart3_1){
          that.chart3_1.resize();
        }
      }
    },
  }
</script>

<style scoped>
  .chart-container {
    width:100%;
    float: left;
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.34px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:80%;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
  .it1{
    width:63%;
  }
  .main-header-right p{
    float: right;
    margin-right:15px;
    margin-top:2px;
  }
  .main-header-right .time{
    font-size:16px;
    letter-spacing:-0.39px;
    color:#0082d2;
    margin-left: 10px;
  }
  .main-header-right button{
    float: right;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    background: #fff;
    border: 1px solid #a3a3a3;
    width:110px;
    height:26px;
    outline: none;
    line-height: 26px;
    margin-top:4px;
    margin-left: 3%;
    cursor: pointer;
  }
  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    color:#fff;
  }
  .main-header-right .set{
    margin-left: 0;
  }

  button span{
    font-family:SFUIText-Regular;
    font-size: 16px;
    letter-spacing:-0.39px;
  }
  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .spe-hr{
    margin-bottom:20px ;
  }

  .chart-container .graph{
    width:100%;
    height:570px;
  }
  @media screen and (max-width: 1500px){
    .chart-container .graph{
      width:100%;
      height:560px;
    }
  }

  .legend-group{
    width:93%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .legend{
    float:left;
    margin-bottom: 15px;
    margin-right:30px;
    height:20px;
    line-height: 20px;
  }
  .legend img{
    margin-right: 8px;
    margin-bottom: 4px;
  }
  .legend-spe2{
    margin-bottom: 20px;
  }

  /*对话框*/
  #dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }
  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:20px 0 10px 10px;
    border:none;
    clear: both;
  }
  .dialog-body .time-range{
    margin-left: 20px;
    height:35px;
    line-height: 35px;
  }
  .time-range p{
    float: left;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-right: 20px;
  }
  .time-range .block{
    float: left;
  }
  .time-range .date{
    float: left;
    width:20%;
    height:35px;
    line-height: 35px;
    font-size: 16px;
    margin-right: 15%;
  }
  .el-date-editor.el-input{
    width:125px;
  }

  .weeks{
    width:92%;
    margin:0 auto;
    margin-top: 30px;
  }
  .weken{
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .weeks span{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
    text-align:left;
    margin-left: 4%;
  }
  .weeks .tittle{
    margin: 0 7% 0 0;
    display: block;
    float: left;
    margin-bottom: 10px;
  }
  .weeks label{
    background: url("../../assets/select yes.png") left 1px no-repeat;
    cursor: pointer;
    padding-left: 18px;
  }
  .weeks .no{
    background: url("../../assets/select no.png") left 1px no-repeat;
  }
  .weeks .weeken-spe{
    margin-left: 5%;
  }

  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 7%;
  }
  .zh2 p{
    font-size: 16px;
  }
  .zh3 span{
    font-size: 15px;
  }
  .weeks .zh4{
    margin-right: 10px;
  }
  .weeks .zh5{
    margin-right: 25px;
  }
  .weeks .de5{
    margin-right: 21px;
  }
  .weeks .it5{
    margin-right: 15px;
  }
  .weeks .it2{
    margin-left: 4%;
  }
  .weeks .po5{
    margin-right: 24px;
  }
  .weeks .po2{
    margin-left: 4.1%;
  }
  .weeks .du5{
    margin-right: 54px;
  }
  .weeks .du2{
    margin-left: 4.6%;
  }

  .weeks .fr3 {
    margin-left: 3%;
  }
  .weeks .sw5{
    margin-right: 51px;
  }
  .weeks .sw2{
    margin-left: 5%;
  }
  .weeks .cz5{
    margin-right: 66px;
  }
  .weeks .cz2{
    margin-left: 4%;
  }

  .statics{
    clear: both;
  }
  .statics-table{
    width: 94%;
    margin:0 auto;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table td{
    height:17px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  #sa_stat_table{
    margin-top:30px;
    margin-bottom:50px;
  }
</style>



// WEBPACK FOOTER //
// chart3.vue?1c4eb304